<!--
	name: CTable   Version: V3.0   by: coon    publish: 2022/08/15;
	include:

	功能：该组件用于实现表格的显示与控制
	可提供如下功能, 支持的形态及功能有:
		1.  支持表头固定在表格最上方, 不随数据向下滚动而被遮挡
		2.  支持固定列、操作列浮动显示、数据列可水平滚动显示
		3.  支持设置表头行高度(ctrl.headHeight)
		4.  支持设置数据行高度(ctrl.dataHeight)
		5.  支持复选框显示(ctrl.isCheck)、全选控制
		6.  支持获取复选框选中值列表(ctrl.self.)
		7.  支持设置表头数据(固定列头-ctrl.dataHeads.head1, 数据列头-ctrl.dataHeads.head2, 操作列头-ctrl.dataHeads.head3)
		8.  支持设置每行的数据(固定列-ctrl.datas.data1, 数据列-ctrl.datas.data2, 操作列-ctrl.datas.data3)
		9.  支持行hover状态
	组件调用参数:
		参数名           必要性    值域              说明
		ctrl: {                                 表格控制参数
			headHeight   必须      int               表头行的高度
			dataHeight   必须      int               数据行的高度
			isCheck      必须      bool              第一列是否显示为复选框
			isSplit      可选      bool              是否为操作列表头生成渐变区域
			onChecked    可选      func              复选框点击时的回调函数
			defChecked   可选      string            默认选中的值列
			lastSum      可选      bool              最后一行是否汇总数据(是汇总数据, 则不显示复选框
			dataHeads:{                              表头参数
				head1:[                              固定列表头, 可指定多个列
					{ capt:'', width:0, align:1 },   表头文本、宽度、数据对齐方式(1-left, 2-center, 3-right)
					...
				],
				head2:[                              数据列表头, 可指定多个列
					{ capt:'', width:0 },            表头文本和宽度
					...
				],
				head3:[                              操作列表头, 可指定多个列
					{ capt:'', width:0 },            表头文本和宽度
					...
				],
			},
			datas:{                                  数据
				data1:[                              固定列
					[ "", "" ],                      每一列的文本, 友情提示, 也可以是html脚本
					...
				],
				data2:[                              数据列
					["","","","","","","","",""],    每一列的文本, 友情提示, 也可以是html脚本
					...
				],
				data3:[                              操作列
					[ "", "" ],                      每一列的文本, 友情提示, 也可以是html脚本
					...
				],
			},
		},
	输出的值:

	外部调用方法:
		getCheckValues()           取得选中复选框的值列表
-->

<template>
	<div id="idTablePanel" ref="idTablePanel" style="width:100%; height:100%; border:1px solid #777777; display:flex; flex-direction:column;">
		<div id="idCTBDPanel" ref="idCTBDPanel" style="flex:1 0 auto; width:100%; display:flex;">
			<div id="idCTHD" ref="idCTHD" style="flex:1 0 auto; border:0px solid blue; display:flex; flex-direction:column;">
				<div id="idHeads" ref="idHeads" style="flex:0 0 auto; border:0px solid red; display:flex;">
					<div id="idHead1" ref="idHead1" style="border:0px solid red; flex:0 0 auto; display:flex;"></div>
					<div id="idHead2" ref="idHead2" style="border:0px solid red; flex:1 0 auto; display:flex; overflow:hidden;"></div>
					<div id="idHead3" ref="idHead3" style="border:0px solid red; flex:0 0 auto; display:flex;"></div>
				</div>
				<div id="idDatas" ref="idDatas" style="flex:1 0 auto; border:0px solid red; display:flex;">
					<div id="idData1" ref="idData1" style="border:0px solid red; flex:0 0 auto; display:flex; flex-direction:column; overflow:hidden;"></div>
					<div id="idData2" ref="idData2" style="border:0px solid red; flex:1 0 auto; display:flex; flex-direction:column; overflow:hidden;"></div>
					<div id="idData3" ref="idData3" style="border:0px solid red; flex:0 0 auto; display:flex; flex-direction:column; overflow:hidden;"></div>
				</div>
			</div>
			<div id="idScrollY" ref="idScrollY" style="flex:0 0 auto; width:18px; height:100%; border:0px solid #777777; overflow-y:scroll;">
				<div id="idSCRY" ref="idSCRY" style="width:1px;"></div>
			</div>
		</div>
		<div style="flex:0 0 auto; height:18px; display:flex;">
			<div id="idScrollX" ref="idScrollX"  style="flex:1 0 auto; height:18px; overflow-x:scroll; border:0px solid #777777;">
				<div id="idSCRX" ref="idSCRX" style="height:1px;"></div>
			</div>
			<div style="flex:0 0 auto; height:18px; width:18px; border:0px solid #777777;"></div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'CTable',
	props:['ctrl'],
	data () {
		return {
			myWidth: 0,                 //表格总体宽度
			myDataWidth: 0,             //滚动列数据的实际宽度
			myW1: 0,                    //固定列宽度
			myW2: 0,                    //数据列宽度
			myW3: 0,                    //操作列宽度
			myRow: "",                  //之前的hover行
			myRows: 0,                  //记录行数
			myClr:["#c3c3c3", "#cccccc", "#d3d3d3", "#dcdcdc", "#e3e3e3", "#eeeeee"],
		}
	},
	mounted: function(){
		//this.myWidth = this.$refs["idTablePanel"].parentNode.offsetWidth;   //此数据为临时数据

		this.$refs["idTablePanel"].onmousewheel = this.onMouseWheel;

		this.$refs["idScrollX"].onscroll = this.onScrollX;
		this.$refs["idScrollY"].onscroll = this.onScrollY;

		this.ctrl.self = this;
	},
	computed:{

	},
	methods:{
		onResize: function(){
			this.myWidth = this.$refs["idTablePanel"].parentNode.offsetWidth;
			this.show();
		},
		onMouseWheel: function( e ){
			let n=this.$refs["idScrollY"].scrollHeight * 0.05;
			if( n < 0 ) n = 10;

			e = e || window.event;
			let y=0;
			if( e.wheelDelta )   //IE/Chrome
				if( e.wheelDelta > 0 ) y = -n;  else y = n;
			else if( e.detail )  //firefox
				if( e.detail > 0     ) y = -n;  else y = n;
			this.$refs["idScrollY"].scrollTop = this.$refs["idScrollY"].scrollTop + y;
			this.onScrollY();
		},
		onScrollX: function(){
			this.$refs["idHead2"].scrollLeft = this.$refs["idScrollX"].scrollLeft;
			this.$refs["idData2"].scrollLeft = this.$refs["idScrollX"].scrollLeft;
		},
		onScrollY: function(){
			this.$refs["idData1"].scrollTop = this.$refs["idScrollY"].scrollTop;
			this.$refs["idData2"].scrollTop = this.$refs["idScrollY"].scrollTop;
			this.$refs["idData3"].scrollTop = this.$refs["idScrollY"].scrollTop;
		},
		show: function(){
			if( this.$refs["idTablePanel"].parentNode==null ) return;

			this.myWidth = this.$refs["idTablePanel"].parentNode.offsetWidth;   //重要

			//计算固定列、数据列、操作列宽度
			this.myW1 = this.myClr.length-1;
			if( this.ctrl.isSplit == false ) this.myW1 = 0;
			for( let i=0; i<this.ctrl.dataHeads.head1.length; i++ ){ this.myW1 = this.myW1 + this.ctrl.dataHeads.head1[i].width; }
			this.$refs["idHead1"].style["width"] = (this.myW1)+"px";

			this.myW3 = this.myClr.length-1;
			if( this.ctrl.isSplit == false ) this.myW3 = 0;
			for( let i=0; i<this.ctrl.dataHeads.head3.length; i++ ){ this.myW3 = this.myW3 + this.ctrl.dataHeads.head3[i].width; }
			this.$refs["idHead3"].style["width"] = (this.myW3)+"px";

			this.myDataWidth = 0;
			for( let i=0; i<this.ctrl.dataHeads.head2.length; i++ ){ this.myDataWidth = this.myDataWidth + this.ctrl.dataHeads.head2[i].width; }
			this.myW2 = this.myWidth - this.myW1 - this.myW3 - 18 - 2;   //2-边框
			this.$refs["idHead2"].style["width"] = (this.myW2)+"px";
			this.$refs["idData2"].style["width"] = (this.myW2)+"px";

			this.$refs["idCTBDPanel"].style["height"]= (this.$refs["idTablePanel"].offsetHeight-18-2)+"px";   //2-边框
			let h=this.$refs["idCTBDPanel"].offsetHeight - this.ctrl.headHeight;
			this.$refs["idData1"].style["height"] = (h)+"px";
			this.$refs["idData2"].style["height"] = (h)+"px";
			this.$refs["idData3"].style["height"] = (h)+"px";

			this.showHeads( "idHead1", this.ctrl.dataHeads.head1 );
			this.showHeads( "idHead2", this.ctrl.dataHeads.head2 );
			this.showHeads( "idHead3", this.ctrl.dataHeads.head3 );
			this.$refs["idScrollX"].style["width"] = (this.myW1+this.myW2+this.myW3)+"px";
			this.$refs["idSCRX"].style["width"] = (this.$refs["idHead2"].scrollWidth + this.myW1 + this.myW3)+"px";

			this.showDatas( "idData1", this.ctrl.datas.data1, this.ctrl.dataHeads.head1 );
			this.showDatas( "idData2", this.ctrl.datas.data2, this.ctrl.dataHeads.head2 );
			this.showDatas( "idData3", this.ctrl.datas.data3, this.ctrl.dataHeads.head3 );
			this.$refs["idScrollY"].style["height"] = (this.$refs["idCTBDPanel"].offsetHeight)+"px";
			this.$refs["idSCRY"].style["height"] = (this.$refs["idData2"].scrollHeight+this.ctrl.headHeight)+"px";

			this.myRows = this.ctrl.datas.data1.length;

			this.procAllCheck( );
		},
		/* private 显示指定的表头 */
		showHeads: function( curName, curHead){
			this.$refs[curName].innerHTML = "";
			let clr="#f1f1f1";

			// 为操作列表头生成渐变区域
			if( curName == "idHead3" )
			{
				if( this.ctrl.isSplit == true )
				{
					for( let i=this.myClr.length-1; 0<i; i-- )
					{
						let ele1=document.createElement("div");
						ele1.setAttribute("style", "width:1px; border:0px; background:"+this.myClr[i]+";");
						this.$refs[curName].appendChild( ele1 );
					}
				}
			}

			for( let i=0; i<curHead.length; i++ )
			{
				//如果是数据区的最后一列, 且实际宽度小于可显示宽度时, 扩大最后一列的实际宽度
				let w=curHead[i].width;
				if( curName == "idHead2" && (i+1)==curHead.length && this.myDataWidth < this.myW2 ) w = w + (this.myW2-this.myDataWidth);

				let ele1=document.createElement("div");
				ele1.setAttribute("class", "CTCell");
				ele1.setAttribute("style", "width:"+w+"px; background:"+clr+";"+
												 "height:"+this.ctrl.headHeight+"px;"+
												 "line-height:"+this.ctrl.headHeight+"px; flex:0 0 auto;");
				ele1.innerHTML = curHead[i].capt;
				this.$refs[curName].appendChild( ele1 );

				// 需要显示渐变区域时
				if( this.ctrl.isSplit == true )
				{
					if( curName=="idHead3" && i==0 ) ele1.style["border-left"] = "1px solid #777777";
				}
				else
				{
					if( curName=="idHead3" && i==0 ) ele1.style["border-left"] = "1px solid #777777";
				}
				if( curName=="idHead2" && (i+1)==curHead.length ) ele1.style["border-right"] = "0px solid #777777";

				if( this.ctrl.isCheck && curName=="idHead1" && i==0 )
				{
					ele1.innerHTML = "";
					ele1.style["display"] = "flex";
					ele1.style["align-items"] = "center";
					ele1.style["justify-content"] = "center";
					let ele2=document.createElement("div");
					ele2.setAttribute("class", "CTChk1");
					ele2.setAttribute("name", "ckCT."+this._uid+".all");
					ele2.setAttribute("checked", false);
					ele2.innerHTML = "<div class='CTUnChecked'></div>";
					ele2.onclick = this.onAllClick;
					ele1.appendChild( ele2 );
				}

				// 需要显示渐变区域时
				if( this.ctrl.isSplit == true )
				{
					if( curName=="idHead1" && (i+1)==curHead.length ) ele1.style["border-right"] = "1px solid "+this.myClr[0];
					if( curName=="idHead3" && i==0 )                  ele1.style["border-left"]  = "1px solid "+this.myClr[0];
				}
			}

			if( curName == "idHead1" )
			{
				if( this.ctrl.isSplit == true )
				{
					for( let i=1; i<this.myClr.length; i++ )
					{
						let ele1=document.createElement("div");
						ele1.setAttribute("style", "width:1px; border:0px; background:"+this.myClr[i]+";");
						this.$refs[curName].appendChild( ele1 );
					}
				}
			}
		},
		/* private 显示指定的数据 */
		showDatas: function( curName, curData, curHead){
			this.$refs[curName].innerHTML = "";

			let clr="#ffffff";
			if( curName=="idData1" ) clr="#f1f1f1";
			let s = "";
			for( let i=0; i<curData.length; i++ )
			{
				let ele1=document.createElement("div");
				ele1.setAttribute("style", "display:flex;" );
				this.$refs[curName].appendChild( ele1 );

				if( curName == "idData3" )
				{
					if( this.ctrl.isSplit == true )
					{
						for( let i=this.myClr.length-1; 0<i; i-- )
						{
							let ele4=document.createElement("div");
							ele4.setAttribute("style", "width:1px; border:0px; background:"+this.myClr[i]+";");
							ele1.appendChild( ele4 );
						}
					}
				}

				for( let j=0; j<curData[i].length; j++ )
				{
					//如果是数据区的最后一列, 且实际宽度小于可显示宽度时, 扩大最后一列的实际宽度
					let w=curHead[j].width;
					if( curName == "idData2" && (j+1)==curHead.length && this.myDataWidth < this.myW2 ) w = w + (this.myW2-this.myDataWidth);

					let ele2=document.createElement("div");
					ele2.setAttribute("class", "CTCell" );
					ele2.setAttribute("name", "R"+(this._uid)+"."+(i+1) );
					ele2.setAttribute("dname", curName );
					ele2.setAttribute("style", "width:"+w+"px; background:"+clr+";"+
													 "height:"+this.ctrl.dataHeight+"px;"+
													 "line-height:"+this.ctrl.dataHeight+"px; flex:0 0 auto; cursor:pointer;" );
					if( curName == "idData3" )
					{
						for( let k=0; k<curData[i][j].length; k++ )
						{
							let curOP=curData[i][j][k];

							let A1=document.createElement("font"); A1.innerText = "[ ";
							let A2=document.createElement("font"); A2.innerText = " ]";
							let A3=document.createElement("font"); A3.innerText = " ";

							let opitem=document.createElement("font");
							if( curOP.clk )
							{
								opitem.setAttribute("class", "OPItem");
								opitem.onclick=function(){ curOP.clk(curOP.param);};
							}
							opitem.innerText = curOP.capt;

							if( 0 < k ) ele2.appendChild( A3 );
							ele2.appendChild( A1 );
							ele2.appendChild( opitem );
							ele2.appendChild( A2 );
						}
					}
					else
					{
						//console.log( Object.prototype.toString.call(curData[i][j]) );
						if( Object.prototype.toString.call(curData[i][j])=="[object Object]" )
						{
							let opitem=document.createElement("font");
							if( curData[i][j].clk )
							{
								opitem.setAttribute("class", "OPItem");
								opitem.onclick=function(){ curData[i][j].clk(curData[i][j].param);};
							}
							opitem.innerText = curData[i][j].capt;

							let A1=document.createElement("font"); A1.innerText = "[ ";
							let A2=document.createElement("font"); A2.innerText = " ]";

							ele2.appendChild( A1 );
							ele2.appendChild( opitem );
							ele2.appendChild( A2 );
						}
						else if( Object.prototype.toString.call(curData[i][j])=="[object HTMLDivElement]" )
						{
							ele2.appendChild( curData[i][j] );
						}
						else
						{
							ele2.innerHTML = curData[i][j];
						}
						if( curHead[j].align )
						{
							if( curHead[j].align==1 ) { ele2.style["text-align"] = "left";   ele2.style["padding-left"]  = "6px"; }
							if( curHead[j].align==3 ) { ele2.style["text-align"] = "right";  ele2.style["padding-right"] = "6px"; }
						}
					}
					ele2.onmouseover = this.onRowOver;
					ele2.onmouseout  = this.onRowOut;

					ele1.appendChild( ele2 );

					if( this.ctrl.isSplit == true )
					{
						if( curName=="idData3" && j==0 ) ele2.style["border-left"] = "1px solid #777777";
					}
					else
					{
						if( curName=="idData3" && j==0 ) ele2.style["border-left"] = "1px solid #777777";
					}
					if( curName=="idData2" && (j+1)==curData[i].length ) ele2.style["border-right"] = "0px solid #777777";

					if( this.ctrl.isCheck && curName=="idData1" && j==0 )
					{
						//console.log( "i="+i+"  j="+j, this.ctrl.lastSum, curData.length-1 );
						if( this.ctrl.lastSum==true && i == (curData.length-1) )  // 最后一行是统计数据, 不显示复选框
							;
						else
						{
							ele2.innerHTML = "";
							ele2.style["display"] = "flex";
							ele2.style["align-items"] = "center";
							ele2.style["justify-content"] = "center";
							let ele3=document.createElement("div");
							ele3.setAttribute("name", "ckCT."+this._uid+".chi");
							ele3.setAttribute("id", "ckCT."+this._uid+".chi."+i);
							ele3.setAttribute("cid", i);            //cid用于取得当前checkbox的序号
							ele3.setAttribute("value", curData[i][j]);
							ele3.setAttribute("class", "CTChk1");
							//console.log( ("[,"+this.ctrl.defChecked+",]"), ("[,"+curData[i][j]+",]"), (","+this.ctrl.defChecked+",").indexOf( (","+curData[i][j]+",") ) );
							if( (this.ctrl.defChecked != "") && (0 <= ( (","+this.ctrl.defChecked+",").indexOf( (","+curData[i][j]+",")))) )
							{
								ele3.setAttribute("checked", true);
								ele3.innerHTML = "<div class='CTChecked' cid='"+i+"'></div>";  //cid用于取得当前checkbox的序号
							}
							else
							{
								ele3.setAttribute("checked", false);
								ele3.innerHTML = "<div class='CTUnChecked' cid='"+i+"'></div>";  //cid用于取得当前checkbox的序号
							}
							ele3.onclick = this.onChiClick;
							ele2.appendChild( ele3 );
						}
					}

					if( this.ctrl.isSplit == true )
					{
						if( curName=="idData1" && (j+1)==curData[i].length ) ele2.style["border-right"] = "1px solid "+this.myClr[0];
						if( curName=="idData3" && j==0 )                     ele2.style["border-left"]  = "1px solid "+this.myClr[0];
					}
				}

				if( curName == "idData1" )
				{
					if( this.ctrl.isSplit == true )
					{
						for( let i=1; i<this.myClr.length; i++ )
						{
							let ele4=document.createElement("div");
							ele4.setAttribute("style", "width:1px; border:0px; background:"+this.myClr[i]+";");
							ele1.appendChild( ele4 );
						}
					}
				}
			}
		},
		onRowOver: function( e ){
			if( this.myRow != "" )
			{
				let eles=document.getElementsByName( this.myRow );
				for( let i=0; i<eles.length; i++ )
				{
					if( eles[i].getAttribute("dname") == "idData1" )
						 eles[i].style["background"] = "#f1f1f1";
					else eles[i].style["background"] = "";
				}
			}

			this.myRow = e.target.getAttribute("name");
			let eles=document.getElementsByName( this.myRow );
			for( let i=0; i<eles.length; i++ )
			{
				eles[i].style["background"] = "#f5f5f5";
			}

		},
		onRowOut: function( e ){
			if( this.myRow != "" )
			{
				let eles=document.getElementsByName( this.myRow );
				for( let i=0; i<eles.length; i++ )
				{
					if( eles[i].getAttribute("dname") == "idData1" )
						 eles[i].style["background"] = "#f1f1f1";
					else eles[i].style["background"] = "";
				}
			}
			this.myRow = "";
		},
		/* public 全选所有的checkbox点击事件 */
		onAllClick: function( e ){
			let obj=document.getElementsByName("ckCT."+this._uid+".all")[0];

			if( obj.getAttribute("checked") == true || obj.getAttribute("checked") == "true" )
			{
				obj.setAttribute("checked", false);
				obj.innerHTML = "<div class='CTUnChecked'></div>";
			}
			else
			{
				obj.setAttribute("checked", true);
				obj.innerHTML = "<div class='CTChecked'></div>";
			}
			this.procAllChildren();

			if( this.ctrl.onChecked ) setTimeout( this.ctrl.onChecked, 100 );
		},
		/* private 单个记录的checkbox点击事件 */
		onChiClick: function( e ){
			let obj=null;
			let obj1=e.target;
			let cid="";
			if( obj1.getAttribute("class")=="CTChk1" )
			{
				obj = obj1;
				cid = obj.getAttribute("cid")+"";
			}
			else
			{
				cid = obj1.getAttribute("cid")+"";
				obj = document.getElementById("ckCT."+this._uid+".chi."+cid);
			}

			if( obj.getAttribute("checked") == true || obj.getAttribute("checked") == "true" )
			{
				obj.setAttribute("checked", false);
				obj.innerHTML = "<div class='CTUnChecked' cid='"+cid+"'></div>";
				this.procAllCheck( );

				if( this.ctrl.onChecked ) setTimeout( this.ctrl.onChecked, 50 );
			}
			else
			{
				obj.setAttribute("checked", true);
				obj.innerHTML = "<div class='CTChecked' cid='"+cid+"'></div>";
				this.procAllCheck( );

				if( this.ctrl.onChecked ) setTimeout( this.ctrl.onChecked, 50 );
			}
		},
		/* private 处理全选状态 */
		procAllChildren: function(){
			let bl=document.getElementsByName("ckCT."+this._uid+".all")[0].getAttribute("checked");
			for( let i=0; i<this.myRows; i++ )
			{
				let obj=document.getElementById("ckCT."+this._uid+".chi."+i);
				if( !obj ) continue;
				if( bl==true || bl=="true" )
				{
					obj.setAttribute("checked", true);
					obj.innerHTML = "<div class='CTChecked' cid='"+i+"'></div>";
				}
				else
				{
					obj.setAttribute("checked", false);
					obj.innerHTML = "<div class='CTUnChecked' cid='"+i+"'></div>";
				}
			}
		},
		/* private 设置全选box的状态 */
		procAllCheck: function( ){
			if( this.myRows==0 || (this.myRows==1 && this.ctrl.lastSum) ) return;

			let bl=true;
			for( let i=0; i<this.myRows; i++ )
			{
				let obj=document.getElementById("ckCT."+this._uid+".chi."+i);
				if( !obj ) continue;
				if( obj.getAttribute("checked")==false || obj.getAttribute("checked")=="false" ) bl = false;
			}

			let obj=document.getElementsByName("ckCT."+this._uid+".all")[0];
			if( !obj ) return;
			if( bl )
			{
				obj.setAttribute("checked", true);
				obj.innerHTML = "<div class='CTChecked'></div>";
			}
			else
			{
				obj.setAttribute("checked", false);
				obj.innerHTML = "<div class='CTUnChecked'></div>";
			}
		},
		/* public 获取复选框选中的值列表  */
		getCheckValues: function( ){
			let s="";
			for( let i=0; i<this.myRows; i++ )
			{
				let obj=document.getElementById("ckCT."+this._uid+".chi."+i);
				if( !obj ) continue;
				if( obj.getAttribute("checked")==true || obj.getAttribute("checked")=="true" )
				{
					if( obj.getAttribute("value")=="" ) continue;
					if( s!="" ) s = s + ",";
					s = s + obj.getAttribute("value");
				}
			}
			return s;
		},
	}
}

</script>

<style>

.CTCell{ padding-left:3px; padding-right:3px; text-align:center; border:1px solid #777777; border-top:0px; border-left:0px; overflow:hidden; white-space:nowrap; text-overflow:ellipsis; }

.CTChk1{ width:18px; height:18px; border:1px solid #777777; border-radius:3px; background:#ffffff; cursor:pointer; }
.CTChk1 .CTChecked{ width:10px; height:10px; border:0px; background:#10c43f; border-radius:3px; margin-left:3px; margin-top:3px; }
.CTChk1 .CTUnChecked{ width:10px; height:10px; border:0px; background:#f45e5e; border-radius:3px; margin-left:3px; margin-top:3px; }

</style>



// WEBPACK FOOTER //
// ctable.vue?11487ae0